import { ApiClient } from './client';

export interface WeeklyAssignment {
  assignmentId: string;
  assignmentStatus: 'pending' | 'completed' | 'expired';
  weekStart: number;
  weekEnd: number;
  assignedAt: string;
  completedAt?: string;
  id: string;
  title: string;
  description: string;
  titleTranslation?: string | null;
  descriptionTranslation?: string | null;
  level: string;
  category: string;
  estimatedTime: number;
  xpReward: number;
  backgroundImage?: string | null;
  status: string;
  progress: number;
  resources: Array<{
    id: string;
    type: 'text' | 'audio' | 'video';
    title: string;
    content?: string;
    url?: string;
  }>;
  activities: Array<{
    id: string;
    type: string;
    [key: string]: unknown;
  }>;
  createdAt: string;
  updatedAt: string;
}

export interface WeeklyAssignmentsResponse {
  weekStart: string;
  weekEnd: string;
  totalAssigned: number;
  completed: number;
  pending: number;
  stories: WeeklyAssignment[];
}

/**
 * Get user's weekly assigned stories
 */
export async function getWeeklyAssignments(): Promise<WeeklyAssignmentsResponse> {
  return ApiClient.get<WeeklyAssignmentsResponse>('/stories/weekly');
}

export interface AllAssignmentsResponse {
  assignments: WeeklyAssignment[];
  total: number;
  offset: number;
  limit: number;
  hasMore: boolean;
}

/**
 * Get all stories ever assigned to the user (all weeks, deduplicated).
 * Supports server-side pagination via limit/offset.
 */
export async function getAllUserAssignments(
  limit = 8,
  offset = 0,
  scope?: 'interest' | 'other'
): Promise<AllAssignmentsResponse> {
  const scopeParam = scope ? `&scope=${scope}` : '';
  return ApiClient.get<AllAssignmentsResponse>(
    `/users/me/assignments?limit=${limit}&offset=${offset}${scopeParam}`
  );
}

/**
 * Mark a story assignment as completed
 */
export async function completeAssignment(storyId: string): Promise<{ success: boolean; message: string }> {
  return ApiClient.post(`/stories/${storyId}/complete`, {});
}
